<template>
  <div class="main-page" @click="menuShow = false">
    <div class="header">
      <div class="header-content">
        <span class="welcome">{{
          userInfo
            ? `${userInfo.nickName}，您好！欢迎使用“马克思主义大辞典”检索资源库！`
            : '欢迎使用“马克思主义大辞典”检索资源库，您还未登录！'
        }}</span>
        <span class="right-text right-text2">
          <span @click="showXcxCheck">手机版</span> |
          <span v-if="!userInfo" @click="showLoginCheck">登录</span>
          <img
            v-else
            class="avatar"
            :src="userInfo.avatarUrl"
            alt=""
            @click.stop="showLogin()"
            @mouseover="showLogin()"
            @mouseout="hideLogin()"
          />
        </span>
        <!-- <span class="right-text"
          >工作委员会
          <el-image
            class="hide-image"
            src="https://file.mashu.cloud/upload/20200912/2020_09_12_151437744.png"
            :preview-src-list="[
              'https://file.mashu.cloud/upload/20200912/2020_09_12_151437744.png',
            ]"
          ></el-image>
        </span> -->
        <span class="right-text"
          >编辑委员会
          <el-image
            class="hide-image"
            src="https://file.mashu.cloud/upload/20200912/2020_09_12_151437655.png"
            :preview-src-list="[
              'https://file.mashu.cloud/upload/20200912/2020_09_12_151437655.png',
            ]"
          ></el-image>
        </span>
      </div>
      <div
        v-if="menuShow"
        class="user-menu"
        @mouseover="showLogin()"
        @mouseout="hideLogin()"
      >
        <div class="user-menu-item" @click.stop="toProfile(0)">
          <img
            :src="require('../../public/images/profile/collect.png')"
            alt=""
            class="user-menu-icon"
          />
          我的收藏
        </div>
        <div class="user-menu-item" @click.stop="toProfile(1)">
          <img
            :src="require('../../public/images/profile/note.png')"
            alt=""
            class="user-menu-icon"
          />
          我的笔记
        </div>
        <div class="user-menu-item" @click.stop="toProfile(2)">
          <img
            :src="require('../../public/images/profile/history.png')"
            alt=""
            class="user-menu-icon"
          />
          历史检索
        </div>
        <div class="user-menu-item" @click.stop="toLogout()">
          <img
            :src="require('../../public/images/profile/exit.png')"
            alt=""
            class="user-menu-icon"
          />
          退出登录
        </div>
      </div>
    </div>
    <router-view></router-view>
    <div v-if="loginShow" class="mask">
      <div class="login">
        <div class="close" @click="loginShow = false"></div>
        <div class="code">
          <wxlogin
            appid="wx28aaa15c1b232d07"
            :scope="scope"
            :redirect_uri="redirect_uri"
            :state="state"
            :href="href"
          ></wxlogin>
        </div>
        <div class="code-text">使用微信扫码登录</div>
      </div>
    </div>

    <div v-if="xcxShow" class="mask">
      <div class="xcx">
        <div class="close" @click="xcxShow = false"></div>
        <div class="xcx-des">
          <div>微信扫码使用移动端小程序，</div>
          <div>检索更便捷！</div>
        </div>
        <div class="xcx-code">
          <img
            :src="require('../../public/images/xcx.jpg')"
            alt=""
            class="xcx-code-img"
          />
        </div>
        <div class="xcx-tips">
          * 手机连接校园网使用小程序，可获得免费检索权限
        </div>
      </div>
    </div>

    <div v-if="xywShow" class="xyw-mask">
      <div class="xyw">
        <div class="xyw-close" @click="xywShow = false"></div>
        <div class="xyw-title">
          <img
            :src="require('../../public/images/tips.png')"
            alt=""
            class="xyw-tips"
          />
          提示
        </div>
        <div class="xyw-des">
          <div>您当前未连接校园网，</div>
          <div>请连接后使用“马克思主义大辞典”检索资源库！</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wxlogin from 'vue-wxlogin'
import { login } from '../service/api'
import Vue from 'vue'
import { getIpState } from '../utils/utils'
Vue.prototype.$EventBus = new Vue()

export default {
  name: 'Main',
  components: {
    wxlogin,
  },
  data: () => {
    return {
      xywShow: false,
      xcxShow: false,
      loginShow: false,
      scope: 'snsapi_login',
      redirect_uri: encodeURIComponent(
        `https://dictionaryofmarxism.com/marx-pc`
      ),
      href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKICBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5pbmZvIHsKICBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUgewogIGJvcmRlcjogbm9uZTsKICB3aWR0aDogMjA0cHg7CiAgaGVpZ2h0OiAyMDRweDsKICBib3JkZXItcmFkaXVzOiAxNnB4Owp9',
      userInfo: null,
      menuShow: false,
    }
  },
  async mounted() {
    // test
    // let userInfo = {
    //   Authorization:
    //     'eyJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJmZW5naHVhbmcwMDEiLCJzdWIiOiJ7XCJ1bmlvbmlkXCI6XCJvQk5GdjZ1eTdTbENXN25saEozRzRzaXc0Q2N3XCJ9IiwidXNlcl9uYW1lIjoieGlhb2ZlbmdodWFuZyIsIm5pY2tfbmFtZSI6IlhJQU9GRU5HSFVBTkciLCJpYXQiOjE2NjAyMjE1MjYsImp0aSI6IjUxZTE0NDcwLTFiMTEtNGY1YS05YTdkLWJlMTYwZmI3MDg4MCJ9.DDrRPnsTExUpyoYDkHcfezoX0I6DJlXaDKZeofGy5_M',
    //   uid: '30920',
    //   unionid: 'oBNFv6uy7SlCW7nlhJ3G4siw4Ccw',
    //   avatarUrl:
    //     'https://thirdwx.qlogo.cn/mmopen/vi_32/TwemaolLFcOe4BtDjaD4fWwc3HzCktGQ6D9xqSxuF4wSuA2mS4OIBC7C60mt5JRbPxYicsntHsWmXHpqybCB4ibQ/132',
    //   openid: 'onUed6U3ESZwAyyliu7QYjhXHrZA',
    //   nickName: 'clooo',
    //   message: '用户登陆成功',
    //   status: true,
    // }
    // sessionStorage.setItem('marxUserInfo', JSON.stringify(userInfo))

    let userInfo = sessionStorage.getItem('marxUserInfo')
      ? JSON.parse(sessionStorage.getItem('marxUserInfo'))
      : null
    if (userInfo) {
      this.userInfo = userInfo
    } else {
      let code = this.getUrlParam('code')
      if (code) {
        let info = await login(code)
        console.log('info', info)
        userInfo = info.data.data
        if (info.data.result) {
          sessionStorage.setItem('marxUserInfo', JSON.stringify(userInfo))
          this.userInfo = userInfo
        }
      }
    }

    this.$EventBus.$on('showlogin', () => {
      this.loginShow = true
    })
  },
  methods: {
    async showXcxCheck() {
      let ipstste = await getIpState()
      if (!ipstste) {
        this.xywShow = true
        return
      }
      this.xcxShow = true
    },
    async showLoginCheck() {
      let ipstste = await getIpState()
      if (!ipstste) {
        this.xywShow = true
        return
      }
      this.loginShow = true
    },

    hideLogining: null,
    hideLogin() {
      this.hideLogining = setTimeout(() => {
        this.menuShow = false
      }, 500)
    },
    showLogin() {
      clearTimeout(this.hideLogining)
      this.menuShow = true
      this.$EventBus.$emit('closeHot')
    },
    toLogout() {
      console.log('退出')
      this.userInfo = null
      sessionStorage.setItem('marxUserInfo', null)
      this.menuShow = false
    },
    toProfile(index) {
      this.$router.push({
        path: '/profile',
        query: { menuIndex: index },
      })
      this.menuShow = false
    },
    getUrlParam(name) {
      let results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
        window.location.href
      )
      if (results === null) {
        return null
      } else {
        return decodeURI(results[1].replace(/[?/]/g, '')) || 0
      }
    },
  },
}
</script>

<style lang="less">
.main-page {
  .header {
    width: 100%;
    height: 50px;
    min-width: 1334px;
    line-height: 50px;
    background: #a00000;
  }
  .user-menu {
    position: absolute;
    z-index: 2;
    top: 59px;
    right: calc((100vw - 1334px) / 2 - 40px);
    box-sizing: border-box;
    width: 154px;
    height: 190px;
    padding: 0 7px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    &::before {
      content: '';
      position: absolute;
      top: -15px;
      right: 39px;
      width: 0;
      height: 0;
      border-bottom: 15px solid #fff;
      border-right: 15px solid transparent;
      border-left: 15px solid transparent;
    }
    .user-menu-item {
      display: flex;
      height: 44px;
      padding-left: 19px;
      align-items: center;
      font-size: 16px;
      color: #333333;
      cursor: pointer;
      &:hover {
        color: #a10f0f;
      }
    }
    .user-menu-icon {
      width: 24px;
      height: 24px;
      margin-right: 12px;
    }
  }

  .header-content {
    width: 1334px;
    margin: 0 auto;
    font-size: 14px;
    color: #fff;

    .welcome {
      float: left;
    }

    .right-text {
      position: relative;
      float: right;
      margin-left: 40px;
      cursor: pointer;
      &:hover {
        font-weight: bold;
      }
    }
    .right-text2 {
      font-weight: normal !important;
    }
    .avatar {
      width: 28px;
      height: 28px;
      margin-left: 4px;
      border-radius: 14px;
      transform: translateY(10px);
    }
    .hide-image {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0;
    }
  }
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 2;
    .login {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 390px;
      height: 488px;
      background: #ffffff;
      border-radius: 20px;
      transform: translate(-50%, -50%);
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 63px;
      height: 63px;
      cursor: pointer;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 2px;
        background-color: #868686;
        transform: translate(-50%, -50%) rotate(45deg);
      }
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 2px;
        background-color: #868686;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }
    .code {
      width: 204px;
      height: 204px;
      margin: 117px 0 34px 45px;
    }
    .code-text {
      text-align: center;
      font-size: 22px;
      color: #1a1a1a;
      font-weight: 400;
    }

    .xcx {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 430px;
      height: 488px;
      background: #ffffff;
      border-radius: 20px;
      transform: translate(-50%, -50%);
      .xcx-des {
        padding-top: 60px;
        line-height: 38px;
        font-size: 22px;
        font-weight: 400;
        color: #1a1a1a;
        text-align: center;
      }
      .xcx-code {
        width: 204px;
        height: 204px;
        margin: 30px auto;
        .xcx-code-img {
          width: 204px;
          height: 204px;
        }
      }
      .xcx-tips {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 34px;
        text-align: center;
      }
    }
  }
  .xyw-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    .xyw {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 720px;
      height: 258px;
      background: #ffffff;
      border-radius: 20px;
      transform: translate(-50%, -50%);
      .xyw-close {
        position: absolute;
        top: 0;
        right: 0;
        width: 63px;
        height: 63px;
        cursor: pointer;
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 20px;
          height: 2px;
          background-color: #868686;
          transform: translate(-50%, -50%) rotate(45deg);
        }
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 20px;
          height: 2px;
          background-color: #868686;
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
      .xyw-title {
        display: flex;
        align-items: center;
        height: 62px;
        padding-top: 20px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 42px;
        .xyw-tips {
          width: 24px;
          height: 24px;
          margin: 0 10px 0 50px;
        }
      }
      .xyw-des {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 44px;
        text-align: center;
      }
    }
  }
}
</style>
